import React from 'react';
import { resolveMediaUrl } from '../utilities/media';

const formatUpdatedDate = (value) => {
  if (!value) return 'Reciente';

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return 'Reciente';
  }

  return parsedDate.toLocaleDateString('es-BO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

const CourseCardInstructor = ({ course, onEdit, onViewStats }) => {
  const studentCount = Number.isFinite(Number(course?.students))
    ? Number(course.students)
    : 0;

  const thumbnailUrl = resolveMediaUrl(
    course?.thumbnail_url,
    'https://via.placeholder.com/400x225?text=Curso'
  );

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      <div className="relative">
        <img
          src={thumbnailUrl}
          alt={course.title}
          className="w-full h-48 object-cover"
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold text-lg mb-2">{course.title}</h3>
        <div className="flex justify-between items-center mb-2">
          <span className={`px-2 py-1 text-xs rounded ${
            course.status === 'published'
              ? 'bg-green-100 text-green-800'
              : 'bg-yellow-100 text-yellow-800'
          }`}>
            {course.status === 'published' ? 'Publicado' : 'Borrador'}
          </span>
          {course.rating ? (
            <span className="text-sm flex items-center">
              <span className="text-yellow-400">★</span> {course.rating}
            </span>
          ) : null}
        </div>
        <div className="flex justify-between items-center text-sm text-gray-600">
          <span>{studentCount} estudiantes</span>
          <span>Actualizado: {formatUpdatedDate(course.updated_at || course.created_at)}</span>
        </div>
        <div className="mt-4 flex space-x-2">
          <button
            type="button"
            onClick={() => onEdit?.(course)}
            className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
          >
            Editar
          </button>
          <button
            type="button"
            onClick={() => onViewStats?.(course)}
            className="px-3 py-1 border border-gray-300 text-sm rounded hover:bg-gray-100"
          >
            Estadisticas
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCardInstructor;
